import { render, staticRenderFns } from "./ResumePage.vue?vue&type=template&id=85ba8184&scoped=true&"
import script from "./ResumePage.vue?vue&type=script&lang=js&"
export * from "./ResumePage.vue?vue&type=script&lang=js&"
import style0 from "./ResumePage.vue?vue&type=style&index=0&id=85ba8184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba8184",
  null
  
)

export default component.exports